module.exports = __webpack_public_path__ + "static/media/wav.89c531a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/wav.svg
// module id = 1690
// module chunks = 17